import React, { useState } from "react";
import { ApprovalAction } from "Shared/types/ApprovalActions";
import { ConfirmActionDialog } from "./ConfirmActionDialog/ConfirmActionDialog";
import { ApprovalActionButton } from "./ApprovalActionButton/ApprovalActionButton";

export interface ApprovalActionsCellProps {
  actions: ApprovalAction[];
  onConfirmAction: (action: ApprovalAction) => void;
  getModalText: (action: ApprovalAction) => string;
  getButtonText: (action: ApprovalAction) => string;
  getQuitButtonText?: (action: ApprovalAction) => string;
}

export const ApprovalActionsCell = ({
  actions,
  onConfirmAction,
  getModalText,
  getButtonText,
  getQuitButtonText,
}: ApprovalActionsCellProps) => {
  const [selectedAction, setSelectedAction] = useState<ApprovalAction | undefined>(undefined);
  const onModalClose = () => { setSelectedAction(undefined); };

  return (
    <>
      {selectedAction && (
        <ConfirmActionDialog
          modalText={getModalText(selectedAction)}
          confirmButtonText={getButtonText(selectedAction)}
          quitButtonText={getQuitButtonText ? getQuitButtonText(selectedAction) : "Cancel"}
          onClose={onModalClose}
          onConfirmAction={() => {
            onConfirmAction(selectedAction);
            onModalClose();
          }}
        />
      )}
      {actions.map(action => (
        <ApprovalActionButton
          key={action}
          action={action}
          onActionButtonClick={() => { setSelectedAction(action); }}
        />
      ))}
    </>
  );
};
